import angular from 'angular';
import uiRouter from 'angular-ui-router';
import botSessionDetailsComponent from './bot-session-details.component';

let botSessionDetailsModule = angular.module('app.containers.bot-session-details', [

])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('botSessionDetails', {
      url: '/bot-sessions/:botSessionId',
      template: '<bot-session-details></bot-session-details>'
    });
})

.component('botSessionDetails', botSessionDetailsComponent);

export default botSessionDetailsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-session-details/bot-session-details.js
 **/